export default __webpack_public_path__ + "static/media/kingalogo.d9c186cc.png";